import { NgModule } from '@angular/core';
import { FormModule } from 'lib/ui/form/form.module.js';
import { CoreModule } from 'src/app/core/core.module.js';
import { GraphsModule } from '../../../../lib/ui/graphs/graphs.module.js';
import { CreateFoodFormButtonComponent } from './create-food-form-button.component.js';
import { FoodFormComponent } from './food-form.component.js';
import { ListGlobalFoodsComponent } from './list-global-foods.component.js';
import { ListMyFoodsComponent } from './list-my-foods.component.js';

@NgModule({
	declarations: [ListMyFoodsComponent, FoodFormComponent, CreateFoodFormButtonComponent, ListGlobalFoodsComponent],
	exports: [ListMyFoodsComponent, FoodFormComponent, CreateFoodFormButtonComponent, ListGlobalFoodsComponent],
	imports: [CoreModule, FormModule, GraphsModule]
})
export class FoodsModule {}
